// ElementTypeGuid
export enum ElementTypeGuidEnum {
  PlateGuid = '51b97c79cf164388b36bf8edc326887c',
  StiffenerGuid = '8a124b71ba374e08aaded3e7073c8bf0',
  FacePlateGuid = '573ef4493c3145128bb99d5daa131795',
  BracketGuid = 'a6ecb8f533f64e7aacb10122adef0d9b',
  ReferenceLineGuid = '35d4384eae2e482abf11b5b81880cd5e'
}

// FormatTypeGuid
export enum FormatTypeGuidEnum {
  LLaminateGuid = '00ac59dd15434cc4875511c41ca0c6ec',
  TLaminateGuid = '0516e45157a94c23a736849c65402a3a',
  ILaminateGuid = 'e7f9efb079cf40caa153cecf86a49cfb',
  BulbGuid = '87e14472aa7e4891b4a5ac56f2c2b159',
  FlatBarGuid = '855e21bcd62d4816a817cd8c03b79269',
  LBuiltGuid = 'e829415d69bb4260ba4d10923ecf7a28',
  TBuiltGuid = '5ea9f3ff1de349999a9e515dfabae689',
  IBuiltGuid = '47bc58e55d9f4326846796cfce711039'
}

// ScopeGuid
export enum ScopeGuidEnum {
  PlateScopeGuid = '23ebb56db4764a04b3885f2e4928de16',
  WebScopeGuid = 'a98545e2ecc64cba8605def21c469f60',
  FlangeScopeGuid = '415900c09a2248099a93ead880d10319'
}
